export const geminiFileResponseMimeType = 'application/json'; 

export const geminiFileResponseSchema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      distributor: {
        type: "string",
        description: "Name of the product distributor"
      },
      manufacturer: {
        type: "string",
        description: "Name of the product manufacturer"
      },
      collection: {
        type: "string",
        nullable: true,
        description: "Product collection/group name"
      },
      style_number: {
        type: "string",
        description: "Unique style identifier (not SKU). Use style name if no style number exists. Apply to all colors of this style"
      },
      style_name: {
        type: "string",
        description: "Style name (groups color options)"
      },
      private_style_number: {
        type: "string",
        nullable: true,
        description: "Private label identifier. Use private style name if no private style number exists. Apply to all colors of this style"
      },
      private_style_name: {
        type: "string",
        nullable: true,
        description: "Private lable for the style name (groups color options)"
      },
      sku: {
        type: "string",
        nullable: true,
        description: "Stock Keeping Unit/Item Number (unique style + color identifier, different from 'style_number')"
      },
      color: {
        type: "string",
        nullable: true,
        description: "Color option name (different from 'style_name')"
      },
      backing_cd: {
        type: "string",
        nullable: true,
        description: "Backing code"
      },
      size_cd: {
        type: "string",
        nullable: true,
        description: "Size of the product. (e.g 12x24)"
      },
      cost: {
        type: "number",
        format: "float",
        description: "Product cost. default to 0.00 if a cost is not found"
      },
      uom_type: {
        type: "string",
        description: "Unit of Measure for cost. Use codes from the provided 'uom_type' list"
      },
      effective_start: {
        type: "string",
        nullable: true,
        description: "Cost start date (YYYY-MM-DD)"
      },
      effective_end: {
        type: "string",
        nullable: true,
        description: "Cost end date. For discontinued products, use provided date or today's date (YYYY-MM-DD)"
      },
      currency_cd: {
        type: "string",
        description: "Currency code (default to USD if not specified)"
      },
      material_class: {
        type: "string",
        description: "Material classification code. Use codes from the provided 'material_class' list. If no direct match, create a concise 3-character code"
      },
      basis_cd: {
        type: "string",
        nullable: true,
        description: "For roll goods: 'CT' for cut price, 'ST' for roll price"
      },
      selling_unit_quantity: {
        type: "string",
        nullable: true,
        description: "Quantity per selling unit (e.g., boxes)"
      },
      selling_unit_uom: {
        type: "string",
        nullable: true,
        description: "Unit of measure for selling unit (e.g., BX for box)"
      },
      thickness: {
        type: "string",
        nullable: true,
        description: "Product thickness (e.g., for LVP/LVT)"
      },
      wear_layer: {
        type: "string",
        nullable: true,
        description: "Wear layer measurement"
      },
      ounce_weight: {
        type: "string",
        nullable: true,
        description: "Carpet face weight/ounce weight"
      },
    },
    required: ["distributor", "manufacturer", "style_number", "style_name", "cost", "uom_type", "material_class"],
    propertyOrdering: [
      "distributor",
      "manufacturer",
      "collection",
      "style_number",
      "style_name",
      "private_style_number",
      "private_style_name",
      "sku",
      "color",
      "backing_cd",
      "size_cd",
      "cost",
      "uom_type",
      "effective_start",
      "effective_end",
      "currency_cd",
      "material_class",
      "basis_cd",
      "selling_unit_quantity",
      "selling_unit_uom",
      "thickness",
      "wear_layer",
      "ounce_weight"
    ]
  },
  description: "Schema for file representing the transformed data from the input file"
};

export const geminiBooleanResponseMimeType = 'text/x.enum'; 

export const geminiBooleanResponseSchema = {
  type: "string",
  nullable: false,
  enum: ['yes', 'no']
}

export const geminiConfig = {
  name: "gemini-2.5-flash",
  temperature: .8,
  topP: 0.95,
  topK: 40,
  maxOutputTokens: 20000,
  thinkingConfig: {
    thinkingBudget: 0,
  }
};